// extracted by mini-css-extract-plugin
export default {"root":"acceptOffers__root__ugbtE","offer":"acceptOffers__offer__RkDN3","checkbox":"acceptOffers__checkbox__mms6n","error":"acceptOffers__error__Pk6vH"};